import { Alert, Snackbar } from "@mui/material";

export default function ErrorModal({ setErrorModal, error, severity = "error" }) {
  return (
    <>
      <Snackbar
        open={true}
        // eslint-disable-next-line no-useless-concat
        key={"top" + "center"}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={4000}
        onClose={() => {
          setErrorModal((prev) => ({ ...prev, state: false }));
        }}
      >
        <Alert
          onClose={() => {
            setErrorModal((prev) => ({ ...prev, state: false }));
          }}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {error}
        </Alert>
      </Snackbar>
    </>
  );
}
